
// CWI CODE J
if ($(".custom_review .review_list").length) {
  $(".custom_review .review_list").each(function(index, review_grid) {
    let review_grid_Swiper = new Swiper(review_grid, {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 32,
      navigation: {
        nextEl: $(review_grid).closest(".custom_review").find(".next_arrow")[0],
        prevEl: $(review_grid).closest(".custom_review").find(".prev_arrow")[0],
      },   
      pagination: {
        el: $(review_grid).closest(".custom_review").find(".review_dot")[0],
        clickable: true,
      },        
      breakpoints: {
        990: {
          slidesPerView: 3,
        },         
        750: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },        
      },      
    });
    // $(".featured_collection_tab").removeClass("hidden");
  });
}